import { render, staticRenderFns } from "./OrgSettings.vue?vue&type=template&id=05443a8c&"
import script from "./OrgSettings.vue?vue&type=script&lang=js&"
export * from "./OrgSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports